import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  Modal,
} from "react-bootstrap";
import api from "../../services/api";

const jenisPelatihanOptions = [
  { kode: "PPH01", nama: "Pelatihan Penyelia Halal UMK Self Declare" },
  { kode: "PPH02", nama: "Pelatihan Penyelia Halal UMK Reguler" },
  { kode: "PPH03", nama: "Pelatihan Penyelia Halal Reguler" },
];

const EntriCalonPeserta = () => {
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [jenisPelatihanList, setJenisPelatihanList] = useState([]);
  const [showSppgForm, setShowSppgForm] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [registrationData, setRegistrationData] = useState({
    no_register: "",
    email: "",
    password: "",
  });
  const [copiedField, setCopiedField] = useState(null);

  const [provinsiList, setProvinsiList] = useState([]);
  const [kabupatenList, setKabupatenList] = useState([]);
  const [kecamatanList, setKecamatanList] = useState([]);
  const [kabupatenListSppg, setKabupatenListSppg] = useState([]);
  const [kecamatanListSppg, setKecamatanListSppg] = useState([]);

  const [formData, setFormData] = useState({
    email: "",
    nama: "",
    no_hp: "",
    tempat_lahir: "",
    tgl_lahir: "",
    nik: "",
    alamat_lengkap: "",
    kode_pos: "",
    provinsi: "",
    kabupaten: "",
    kecamatan: "",
    nama_instansi: "",
    is_penyelia_halal_sppg: false,
    nama_sppg: "",
    alamat_sppg: "",
    provinsi_sppg: "",
    kabupaten_sppg: "",
    kecamatan_sppg: "",
    kelurahan_sppg: "",
    jenis_pelatihan: "",
    angkatan: "",
  });

  const [files, setFiles] = useState({
    file_ktp: null,
    file_foto: null,
    bukti_pembayaran: null,
  });

  const showError = (msg) => {
    setError(msg);
    setShowErrorModal(true);
  };

  useEffect(() => {
    fetchJenisPelatihan();
    fetchProvinsi();
  }, []);

  const fetchJenisPelatihan = async () => {
    try {
      setLoading(true);
      const response = await api.get("/pendaftaran-penyelia/jenis-pelatihan");
      if (response.data.success) {
        setJenisPelatihanList(response.data.data);
        if (response.data.data.length > 0) {
          setFormData((prev) => ({
            ...prev,
            jenis_pelatihan: response.data.data[0].jenis_pelatihan,
            angkatan: response.data.data[0].angkatan,
          }));
        }
      }
    } catch (err) {
      console.error("Error fetching jenis pelatihan:", err);
      showError("Gagal mengambil data jenis pelatihan");
    } finally {
      setLoading(false);
    }
  };

  const fetchProvinsi = async () => {
    try {
      const response = await api.get("/pendaftaran-penyelia/provinsi");
      if (response.data.success) {
        setProvinsiList(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching provinsi:", err);
    }
  };

  const fetchKabupaten = async (kodeprovinsi, isSppg = false) => {
    try {
      const response = await api.get(
        `/pendaftaran-penyelia/kabupaten/${kodeprovinsi}`
      );
      if (response.data.success) {
        if (isSppg) {
          setKabupatenListSppg(response.data.data);
          setKecamatanListSppg([]);
        } else {
          setKabupatenList(response.data.data);
          setKecamatanList([]);
        }
      }
    } catch (err) {
      console.error("Error fetching kabupaten:", err);
    }
  };

  const fetchKecamatan = async (kodekabupaten, isSppg = false) => {
    try {
      const response = await api.get(
        `/pendaftaran-penyelia/kecamatan/${kodekabupaten}`
      );
      if (response.data.success) {
        if (isSppg) {
          setKecamatanListSppg(response.data.data);
        } else {
          setKecamatanList(response.data.data);
        }
      }
    } catch (err) {
      console.error("Error fetching kecamatan:", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "is_penyelia_halal_sppg") {
      setShowSppgForm(checked);
    }

    if (name === "jenis_pelatihan") {
      const selected = jenisPelatihanList.find(
        (j) => j.jenis_pelatihan === value
      );
      if (selected) {
        setFormData((prev) => ({
          ...prev,
          jenis_pelatihan: selected.jenis_pelatihan,
          angkatan: selected.angkatan,
        }));
      }
    }

    if (name === "provinsi") {
      setFormData((prev) => ({
        ...prev,
        provinsi: value,
        kabupaten: "",
        kecamatan: "",
      }));
      if (value) fetchKabupaten(value, false);
      else setKabupatenList([]);
    }

    if (name === "kabupaten") {
      setFormData((prev) => ({ ...prev, kabupaten: value, kecamatan: "" }));
      if (value) fetchKecamatan(value, false);
      else setKecamatanList([]);
    }

    if (name === "provinsi_sppg") {
      setFormData((prev) => ({
        ...prev,
        provinsi_sppg: value,
        kabupaten_sppg: "",
        kecamatan_sppg: "",
      }));
      if (value) fetchKabupaten(value, true);
      else setKabupatenListSppg([]);
    }

    if (name === "kabupaten_sppg") {
      setFormData((prev) => ({
        ...prev,
        kabupaten_sppg: value,
        kecamatan_sppg: "",
      }));
      if (value) fetchKecamatan(value, true);
      else setKecamatanListSppg([]);
    }
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles && selectedFiles[0]) {
      setFiles((prev) => ({ ...prev, [name]: selectedFiles[0] }));
    }
  };

  const resetForm = () => {
    setFormData({
      email: "",
      nama: "",
      no_hp: "",
      tempat_lahir: "",
      tgl_lahir: "",
      nik: "",
      alamat_lengkap: "",
      kode_pos: "",
      provinsi: "",
      kabupaten: "",
      kecamatan: "",
      nama_instansi: "",
      is_penyelia_halal_sppg: false,
      nama_sppg: "",
      alamat_sppg: "",
      provinsi_sppg: "",
      kabupaten_sppg: "",
      kecamatan_sppg: "",
      kelurahan_sppg: "",
      jenis_pelatihan: jenisPelatihanList[0]?.jenis_pelatihan || "",
      angkatan: jenisPelatihanList[0]?.angkatan || "",
    });
    setFiles({ file_ktp: null, file_foto: null, bukti_pembayaran: null });
    setKabupatenList([]);
    setKecamatanList([]);
    setKabupatenListSppg([]);
    setKecamatanListSppg([]);
    setShowSppgForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.email || !formData.nama || !formData.nik || !formData.no_hp) {
      showError("Email, Nama, NIK, dan No. HP wajib diisi");
      return;
    }

    if (!files.file_ktp || !files.file_foto) {
      showError("File KTP dan Foto wajib diupload");
      return;
    }

    if (formData.tgl_lahir) {
      const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const match = formData.tgl_lahir.match(dateRegex);
      if (!match) {
        showError(
          "Format tanggal lahir tidak valid. Gunakan format dd/MM/yyyy (contoh: 25/08/1990)"
        );
        return;
      }
      const [, dd, mm, yyyy] = match;
      const dateObj = new Date(`${yyyy}-${mm}-${dd}`);
      const isValidDate =
        dateObj instanceof Date &&
        !isNaN(dateObj) &&
        dateObj.getFullYear() === parseInt(yyyy) &&
        dateObj.getMonth() + 1 === parseInt(mm) &&
        dateObj.getDate() === parseInt(dd);
      if (!isValidDate) {
        showError(
          "Tanggal lahir tidak valid. Pastikan tanggal, bulan, dan tahun sudah benar."
        );
        return;
      }
      const today = new Date();
      if (dateObj >= today) {
        showError("Tanggal lahir tidak boleh hari ini atau di masa depan.");
        return;
      }
    }

    try {
      setSubmitting(true);
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (key === "tgl_lahir" && formData[key]) {
          const parts = formData[key].split("/");
          if (parts.length === 3) {
            data.append(key, `${parts[2]}-${parts[1]}-${parts[0]}`);
          } else {
            data.append(key, formData[key]);
          }
        } else {
          data.append(key, formData[key]);
        }
      });

      if (files.file_ktp) data.append("file_ktp", files.file_ktp);
      if (files.file_foto) data.append("file_foto", files.file_foto);
      if (files.bukti_pembayaran)
        data.append("bukti_pembayaran", files.bukti_pembayaran);

      const response = await api.post("/pendaftaran-penyelia", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        const { no_register, email, password } = response.data.data || {};
        setRegistrationData({
          no_register: no_register || "",
          email: email || formData.email,
          password: password || formData.no_hp,
        });
        setShowSuccessModal(true);
        resetForm();
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      const serverError =
        err.response?.data?.error || err.response?.data?.message;
      showError(serverError || "Terjadi kesalahan saat menyimpan data");
    } finally {
      setSubmitting(false);
    }
  };

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    });
  };

  const getJenisPelatihanNama = (kode) => {
    const found = jenisPelatihanOptions.find((j) => j.kode === kode);
    return found ? found.nama : kode;
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" />
        <p className="mt-3">Memuat data...</p>
      </Container>
    );
  }

  return (
    <Container fluid className="py-4">
      <Row className="justify-content-center">
        <Col lg={10}>
          <Card>
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">
                <i className="fas fa-user-plus me-2"></i>
                Entri Calon Peserta Pelatihan Penyelia Halal
              </h4>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                {/* Data Pribadi */}
                <h5 className="mb-3 border-bottom pb-2">Data Pribadi</h5>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Email <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="email@example.com"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Nama Lengkap <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="nama"
                        value={formData.nama}
                        onChange={handleInputChange}
                        placeholder="Nama lengkap sesuai KTP"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        No. HP <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="no_hp"
                        value={formData.no_hp}
                        onChange={handleInputChange}
                        placeholder="08123456789"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        NIK <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="nik"
                        value={formData.nik}
                        onChange={handleInputChange}
                        placeholder="16 digit NIK"
                        maxLength={16}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Tempat Lahir</Form.Label>
                      <Form.Control
                        type="text"
                        name="tempat_lahir"
                        value={formData.tempat_lahir}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Tanggal Lahir</Form.Label>
                      <Form.Control
                        type="text"
                        name="tgl_lahir"
                        value={formData.tgl_lahir}
                        onChange={handleInputChange}
                        placeholder="dd/MM/yyyy"
                        maxLength={10}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Alamat */}
                <h5 className="mb-3 mt-4 border-bottom pb-2">Alamat</h5>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Alamat Lengkap (tulis alamat sesuai KTP)
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="alamat_lengkap"
                    value={formData.alamat_lengkap}
                    onChange={handleInputChange}
                  />
                </Form.Group>

                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Provinsi</Form.Label>
                      <Form.Select
                        name="provinsi"
                        value={formData.provinsi}
                        onChange={handleInputChange}
                      >
                        <option value="">Pilih Provinsi</option>
                        {provinsiList.map((prov) => (
                          <option
                            key={prov.kodeprovinsi}
                            value={prov.kodeprovinsi}
                          >
                            {prov.namaprovinsi}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Kabupaten/Kota</Form.Label>
                      <Form.Select
                        name="kabupaten"
                        value={formData.kabupaten}
                        onChange={handleInputChange}
                        disabled={!formData.provinsi}
                      >
                        <option value="">Pilih Kabupaten/Kota</option>
                        {kabupatenList.map((kab) => (
                          <option
                            key={kab.kodekabupaten}
                            value={kab.kodekabupaten}
                          >
                            {kab.namakabupaten}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Kecamatan</Form.Label>
                      <Form.Select
                        name="kecamatan"
                        value={formData.kecamatan}
                        onChange={handleInputChange}
                        disabled={!formData.kabupaten}
                      >
                        <option value="">Pilih Kecamatan</option>
                        {kecamatanList.map((kec) => (
                          <option
                            key={kec.kodekecamatan}
                            value={kec.kodekecamatan}
                          >
                            {kec.namakecamatan}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Kode Pos</Form.Label>
                      <Form.Control
                        type="text"
                        name="kode_pos"
                        value={formData.kode_pos}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Instansi */}
                <h5 className="mb-3 mt-4 border-bottom pb-2">Data Instansi</h5>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Nama Instansi/Perusahaan (nama instansi/nama usaha/SPPG
                    atau ditulis "Mandiri" jika tidak terafiliasi instansi
                    manapun)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="nama_instansi"
                    value={formData.nama_instansi}
                    onChange={handleInputChange}
                    placeholder="Nama instansi atau perusahaan"
                  />
                </Form.Group>

                {/* Jenis Pelatihan */}
                <h5 className="mb-3 mt-4 border-bottom pb-2">
                  Jenis Pelatihan
                </h5>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Jenis Pelatihan <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        name="jenis_pelatihan"
                        value={formData.jenis_pelatihan}
                        onChange={handleInputChange}
                        required
                      >
                        {jenisPelatihanList.map((item, index) => (
                          <option key={index} value={item.jenis_pelatihan}>
                            {getJenisPelatihanNama(item.jenis_pelatihan)} -{" "}
                            {item.angkatan}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Angkatan</Form.Label>
                      <Form.Control
                        type="text"
                        name="angkatan"
                        value={formData.angkatan}
                        onChange={handleInputChange}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* SPPG */}
                <h5 className="mb-3 mt-4 border-bottom pb-2">
                  Data SPPG (Opsional)
                </h5>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="is_penyelia_halal_sppg"
                    checked={formData.is_penyelia_halal_sppg}
                    onChange={handleInputChange}
                    label="Peserta adalah Penyelia Halal SPPG"
                  />
                </Form.Group>

                {showSppgForm && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Nama SPPG</Form.Label>
                          <Form.Control
                            type="text"
                            name="nama_sppg"
                            value={formData.nama_sppg}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Alamat SPPG</Form.Label>
                          <Form.Control
                            type="text"
                            name="alamat_sppg"
                            value={formData.alamat_sppg}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Provinsi SPPG</Form.Label>
                          <Form.Select
                            name="provinsi_sppg"
                            value={formData.provinsi_sppg}
                            onChange={handleInputChange}
                          >
                            <option value="">Pilih Provinsi</option>
                            {provinsiList.map((prov) => (
                              <option
                                key={prov.kodeprovinsi}
                                value={prov.kodeprovinsi}
                              >
                                {prov.namaprovinsi}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Kabupaten SPPG</Form.Label>
                          <Form.Select
                            name="kabupaten_sppg"
                            value={formData.kabupaten_sppg}
                            onChange={handleInputChange}
                            disabled={!formData.provinsi_sppg}
                          >
                            <option value="">Pilih Kabupaten</option>
                            {kabupatenListSppg.map((kab) => (
                              <option
                                key={kab.kodekabupaten}
                                value={kab.kodekabupaten}
                              >
                                {kab.namakabupaten}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Kecamatan SPPG</Form.Label>
                          <Form.Select
                            name="kecamatan_sppg"
                            value={formData.kecamatan_sppg}
                            onChange={handleInputChange}
                            disabled={!formData.kabupaten_sppg}
                          >
                            <option value="">Pilih Kecamatan</option>
                            {kecamatanListSppg.map((kec) => (
                              <option
                                key={kec.kodekecamatan}
                                value={kec.kodekecamatan}
                              >
                                {kec.namakecamatan}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Kelurahan SPPG</Form.Label>
                          <Form.Control
                            type="text"
                            name="kelurahan_sppg"
                            value={formData.kelurahan_sppg}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}

                {/* Upload File */}
                <h5 className="mb-3 mt-4 border-bottom pb-2">
                  Upload Dokumen
                </h5>
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        File KTP <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="file_ktp"
                        onChange={handleFileChange}
                        accept=".jpg,.jpeg,.png,.pdf"
                        required
                      />
                      <Form.Text className="text-muted">
                        Format: JPG, PNG, PDF (Max 5MB)
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Foto Diri <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="file_foto"
                        onChange={handleFileChange}
                        accept=".jpg,.jpeg,.png"
                        required
                      />
                      <Form.Text className="text-muted">
                        Format: JPG, PNG (Max 5MB)
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Bukti Pembayaran</Form.Label>
                      <Form.Control
                        type="file"
                        name="bukti_pembayaran"
                        onChange={handleFileChange}
                        accept=".jpg,.jpeg,.png,.pdf"
                      />
                      <Form.Text className="text-muted">
                        Format: JPG, PNG, PDF (Max 5MB)
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex gap-2 mt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    size="lg"
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Menyimpan...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-save me-2"></i>
                        Simpan Data
                      </>
                    )}
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="lg"
                    type="button"
                    onClick={resetForm}
                    disabled={submitting}
                  >
                    <i className="fas fa-redo me-2"></i>
                    Reset
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Error Modal */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
      >
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>Terjadi Kesalahan</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <div
            style={{ fontSize: "3rem", color: "#dc3545", marginBottom: "1rem" }}
          >
            &#9888;
          </div>
          <p className="mb-0">{error}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowErrorModal(false)}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title>
            <i className="fas fa-check-circle me-2"></i>
            Data Berhasil Disimpan!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="text-center mb-4">
            <i
              className="fas fa-check-circle text-success"
              style={{ fontSize: "4rem" }}
            ></i>
          </div>
          <h5 className="text-center mb-4">
            Calon peserta berhasil dimasukkan ke sistem!
          </h5>

          <Alert variant="info" className="mb-4">
            <Alert.Heading className="h6">
              <i className="fas fa-id-card me-2"></i>
              Nomor Register
            </Alert.Heading>
            <div className="text-center">
              <h3 className="mb-0 font-monospace">
                {registrationData.no_register}
              </h3>
            </div>
            <hr />
            <p className="mb-0 small">
              Simpan nomor register ini untuk referensi peserta
            </p>
          </Alert>

          <Alert variant="primary">
            <Alert.Heading className="h6">
              <i className="fas fa-key me-2"></i>
              Informasi Login Peserta
            </Alert.Heading>
            <div className="mt-3">
              <Row className="mb-2">
                <Col xs={4} className="fw-bold">
                  Email/Username:
                </Col>
                <Col xs={8}>
                  <div className="d-flex align-items-center gap-2">
                    <code className="bg-light px-2 py-1 rounded">
                      {registrationData.email}
                    </code>
                    <Button
                      variant={
                        copiedField === "email" ? "success" : "outline-secondary"
                      }
                      size="sm"
                      onClick={() =>
                        copyToClipboard(registrationData.email, "email")
                      }
                      title="Salin email"
                    >
                      <i
                        className={`fas fa-${copiedField === "email" ? "check" : "copy"}`}
                      ></i>
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={4} className="fw-bold">
                  Password:
                </Col>
                <Col xs={8}>
                  <div className="d-flex align-items-center gap-2">
                    <code className="bg-light px-2 py-1 rounded">
                      {registrationData.password}
                    </code>
                    <Button
                      variant={
                        copiedField === "password"
                          ? "success"
                          : "outline-secondary"
                      }
                      size="sm"
                      onClick={() =>
                        copyToClipboard(registrationData.password, "password")
                      }
                      title="Salin password"
                    >
                      <i
                        className={`fas fa-${copiedField === "password" ? "check" : "copy"}`}
                      ></i>
                    </Button>
                  </div>
                  <small className="d-block text-muted mt-1">
                    (Password default: nomor HP peserta)
                  </small>
                </Col>
              </Row>
            </div>
            <hr />
            <p className="mb-0 small text-muted">
              <i className="fas fa-exclamation-triangle me-1"></i>
              Sampaikan informasi login ini kepada peserta yang bersangkutan.
            </p>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSuccessModal(false)}
          >
            Tutup
          </Button>
          <Button
            variant="success"
            onClick={() => setShowSuccessModal(false)}
          >
            <i className="fas fa-user-plus me-2"></i>
            Entri Peserta Baru
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default EntriCalonPeserta;
